var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16.798,
    viewBox: "0 0 18 16.798",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13267",
    "data-name": "Group 13267",
    transform: "translate(-836 -496.3)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "question",
    transform: "translate(842.651 500.815)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3791",
    "data-name": "Path 3791",
    d: "M11.813,10.067h1.142a1.1,1.1,0,0,1,1.177-1.2A1,1,0,0,1,15.268,9.88c0,.55-.324.8-.835,1.187a1.971,1.971,0,0,0-1.011,1.72l.006.4H14.56V12.88c0-.621.236-.8.874-1.286A2.112,2.112,0,0,0,16.51,9.814c0-1.308-1.1-1.939-2.313-1.939a2.121,2.121,0,0,0-2.384,2.192Zm1.352,4.774a.885.885,0,1,0,.873-.813.815.815,0,0,0-.873.813Z",
    transform: "translate(-11.813 -7.875)",
    fill: "#74613c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "chat",
    transform: "translate(836 496.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3792",
    "data-name": "Path 3792",
    d: "M3.013,14.506a1.125,1.125,0,0,1,.323.9,12.341,12.341,0,0,1-.448,2.25,13.28,13.28,0,0,0,2.963-1,1.125,1.125,0,0,1,.8-.083A9.067,9.067,0,0,0,9,16.875c4.5,0,7.875-3.158,7.875-6.75S13.5,3.375,9,3.375s-7.875,3.159-7.875,6.75a6.181,6.181,0,0,0,1.888,4.38ZM2.458,18.9q-.4.079-.8.145a.292.292,0,0,1-.307-.407q.15-.353.274-.716l0-.011A11.765,11.765,0,0,0,2.217,15.3,7.306,7.306,0,0,1,0,10.125C0,5.775,4.03,2.25,9,2.25s9,3.526,9,7.875S13.97,18,9,18a10.193,10.193,0,0,1-2.64-.345,15.381,15.381,0,0,1-3.9,1.243Z",
    transform: "translate(0 -2.25)",
    fill: "#74613c",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuery);
export default __webpack_public_path__ + "static/media/Query.d363fa5623acb561ea9c904e8bcc12a7.svg";
export { ForwardRef as ReactComponent };